import { handleApi } from "common/utils/handleApi";
import { baseApiService } from "shared/api";
import { client } from "shared/api/client";

export const uploadStatementApi = async (data) => {
  return await handleApi(() =>
    client.post(
      baseApiService.ENDPOINTS.local_admin.credit_cards.upload_statement,
      data
    )
  );
};
